import React, { useRef } from 'react';
import { h2Bottom } from '../../assets'
import {
    Form,
    Input,
    Button,
    Col,
    Row
} from 'antd';
import emailjs from 'emailjs-com';
import Swal from 'sweetalert2';
const { TextArea } = Input;
function FormContact() {
    const form = useRef();

    function sendEmail(e) {
        console.log(form.current);
        emailjs.sendForm(
            'service_rcxaoq6',
            'template_y8q32t4',
            form.current,
            'xEejSK0MqBOqjbDjC'
        )
            .then((result) => {
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: e.Name + ' your response submitted successfully!'
                })
            }, (error) => {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: e.Name + ` your response didn't submitted try again later ! `
                })
            });

    };

    return (
        <div className='section contactUsForm'>
            <Row align='center'>
                <Col span={22}>
                    <h1>LET'S HAVE A TALK!</h1>
                    <img src={h2Bottom} alt="img" />
                </Col>
            </Row>
            <Row justify='space-between' align='middle' style={{ marginTop: "50px" }}>
                <Col span={8} lg={11} sm={{ span: 24, }} xs={24}>
                    <div>
                        <p className="pSmall" >
                            <b> Hi ! it's me Usama, </b><br />
                            If you have any question about Rapidev Games regarding any thing feel free to contact us. We would love to solve your queries and serve you in the field of game development.

                        </p>
                    </div>
                </Col>
                <Col span={10} lg={12} md={24} sm={{ span: 24, order: '1' }} xs={24} >
                    {/* <form onSubmit={sendEmail} ref={form}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '1rem',
                            color: 'black !important'
                        }}
                    >
                        <input type="text" name='name'
                            style={{ color: 'black !important' }} />
                        <input type="email" name='email' />

                        <input type="text" name='subject' />

                        <input type="text" name='message' />

                        <input type="submit" value="submit" style={{ color: 'black !important' }} />

                    </form> */}
                    <Form
                        layout="horizontal"
                        ref={form}
                        // onSubmitCapture={sendEmail}
                        onFinish={(e) => sendEmail(e)}
                    >
                        <Form.Item
                            name={'name'}
                            rules={[
                                {
                                    required: true,
                                    message: 'name is required',
                                },
                            ]}
                        >
                            <Input placeholder='Your Name' />
                        </Form.Item>
                        <Form.Item
                            name={'email'}
                            rules={[
                                {
                                    required: true,
                                    message: 'email is required',
                                },
                            ]}
                        >
                            <Input placeholder='Email..' type={'email'} />
                        </Form.Item>
                        <Form.Item
                            name={'subject'}
                            rules={[
                                {
                                    required: true,
                                    message: 'subject is required',
                                },
                            ]}
                        >
                            <Input type={'text'} placeholder='Subject' />
                        </Form.Item>
                        <Form.Item
                            name={'Message'}
                            rules={[
                                {
                                    required: true,
                                    message: 'Message is required',
                                },
                            ]}
                        >
                            <TextArea rows={4} placeholder='Your Message ....' />
                        </Form.Item>
                        <Form.Item >
                            <Button htmlType='submit' className='btn' onSubmit={sendEmail}>Submit</Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </div>
    )
}

export default FormContact